import React from 'react';
import BrowsingContent from 'components/browsing/BrowsingContent';

const BrowsingPage = (): JSX.Element => {
  return <BrowsingContent />;
};

export default BrowsingPage;
